export default __webpack_public_path__ + "static/media/bruno-matzke2.b9c46733.webp";